import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Globe } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_auto-calc-form/artifacts/mg0g3ttm_Renewbee-Bee-Vector-Wide.svg";

export const Header = ({ language, setLanguage, t }) => {
  return (
    <header className="bg-card border-b border-border sticky top-0 z-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src={LOGO_URL} 
              alt="RenewBee" 
              className="h-12 sm:h-14 w-auto"
            />
          </div>

          {/* Language Selector */}
          <div className="flex items-center gap-2">
            <Globe className="w-4 h-4 text-muted-foreground" />
            <Tabs value={language} onValueChange={setLanguage}>
              <TabsList className="bg-muted">
                <TabsTrigger 
                  value="de" 
                  className="text-xs px-3 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
                >
                  🇩🇪 Deutsch
                </TabsTrigger>
                <TabsTrigger 
                  value="en"
                  className="text-xs px-3 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground"
                >
                  🇬🇧 English
                </TabsTrigger>
              </TabsList>
            </Tabs>
          </div>
        </div>

        {/* Subtitle */}
        <div className="mt-4 text-center sm:text-left">
          <h2 className="text-lg sm:text-xl font-semibold text-foreground">
            {t.title}
          </h2>
        </div>
      </div>
    </header>
  );
};

export default Header;
